import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { GameActivityThree } from './GameActivityThree';
import { questions } from '../../../assets/tema6/questionCellActivity';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	questions: 3,
	win: 4,
	fail: 5
};

const stepThree = {

}
const gameQuestion = [
	{
		id: 1,
		options: [
			{
				id: 1,
				imgNeutral: questions.question1.option1.opt1_neutral,
				imgSelected: questions.question1.option1.opt1_selected,
				imgResult: questions.question1.option1.opt1_result,
			},
			{
				id: 2,
				imgNeutral: questions.question1.option2.opt2_neutral,
				imgSelected: questions.question1.option2.opt2_selected,
				imgResult: questions.question1.option2.opt2_result,
				isCorrect: true
			},
			{
				id: 3,
				imgNeutral: questions.question1.option3.opt3_neutral,
				imgSelected: questions.question1.option3.opt3_selected,
				imgResult: questions.question1.option3.opt3_result,
			},
			{
				id: 4,
				imgNeutral: questions.question1.option4.opt4_neutral,
				imgSelected: questions.question1.option4.opt4_selected,
				imgResult: questions.question1.option4.opt4_result,
			},
		]
	},
	{
		id: 2,
		options: [
			{
				id: 1,
				imgNeutral: questions.question2.option1.opt1_neutral,
				imgSelected: questions.question2.option1.opt1_selected,
				imgResult: questions.question2.option1.opt1_result,
				isCorrect: true,
			},
			{
				id: 2,
				imgNeutral: questions.question2.option2.opt2_neutral,
				imgSelected: questions.question2.option2.opt2_selected,
				imgResult: questions.question2.option2.opt2_result,
			},
			{
				id: 3,
				imgNeutral: questions.question2.option3.opt3_neutral,
				imgSelected: questions.question2.option3.opt3_selected,
				imgResult: questions.question2.option3.opt3_result,
			},
			{
				id: 4,
				imgNeutral: questions.question2.option4.opt4_neutral,
				imgSelected: questions.question2.option4.opt4_selected,
				imgResult: questions.question2.option4.opt4_result,
			},
		]
	},
	{
		id: 3,
		options: [
			{
				id: 1,
				imgNeutral: questions.question3.option1.opt1_neutral,
				imgSelected: questions.question3.option1.opt1_selected,
				imgResult: questions.question3.option1.opt1_result,
				isCorrect: true,
			},
			{
				id: 2,
				imgNeutral: questions.question3.option2.opt2_neutral,
				imgSelected: questions.question3.option2.opt2_selected,
				imgResult: questions.question3.option2.opt2_result,
			},
			{
				id: 3,
				imgNeutral: questions.question3.option3.opt3_neutral,
				imgSelected: questions.question3.option3.opt3_selected,
				imgResult: questions.question3.option3.opt3_result,
			},
			{
				id: 4,
				imgNeutral: questions.question3.option4.opt4_neutral,
				imgSelected: questions.question3.option4.opt4_selected,
				imgResult: questions.question3.option4.opt4_result,
			},
		]
	},
]
let pointsAcumulated = 0

export const Theme6SubtopicThreeActivityThree = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema6.activities.subtema3], 3);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 6 sub 3 act 3");
			ObserverEmitter.emit(EVENTS.tema6.topic3.initScene, 3);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T6.sub03.sub3_act3_a01)
	})

	ObserverEmitter.on(EVENTS.tema6.topic3.listenScene, (step = "") => {
		const valuesObj = stepThree[step]
		if (!valuesObj) {
			return
		}
		valuesObj.action()
		setUiToShow(valuesObj.ui)
	})

	const [selectQuestionGame, setSelectQuestionGame] = useState({
		options: [
			{
				id: 1,
				imgNeutral: "",
				imgSelected: "",
				imgResult: "",
			},
			{
				id: 2,
				imgNeutral: "",
				imgSelected: "",
				imgResult: "",
			},
			{
				id: 3,
				imgNeutral: "",
				imgSelected: "",
				imgResult: "",
			},
			{
				id: 4,
				imgNeutral: "",
				imgSelected: "",
				imgResult: "",
			},
		]
	})
	const [numberQuestion, setNumberQuestion] = useState(0)
	const [saveResponse, setSaveResponse] = useState(0)

	const actionGameQuestion = (statusCorrect = 0) => {
		const updatedResponse = statusCorrect === 1 ? saveResponse + 1 : saveResponse;
		setSaveResponse(updatedResponse);

		// console.log(updatedResponse);
		pointsAcumulated = updatedResponse * 10

		if (numberQuestion >= gameQuestion.length - 1) {
			ObserverEmitter.emit(EVENTS.tema6.topic3.actScene, "hide_desk_phone");
			if (updatedResponse >= 2) {
				setUiToShow(steps.win);
			} else {
				setUiToShow(steps.fail);
			}
			return;
		}
		setNumberQuestion(numberQuestion + 1);

		// console.log(numberQuestion);
		switch (numberQuestion) {
			case 0:
				ObserverEmitter.emit(EVENTS.tema6.topic3.actScene, "texture_2");
				break;
			case 1:
				ObserverEmitter.emit(EVENTS.tema6.topic3.actScene, "texture_3");
				break;
			default:
				break;
		}
	};

	const setDataQuestion = () => {
		const selectData = gameQuestion[numberQuestion]
		setSelectQuestionGame(selectData)
	}

	useEffect(() => {
		setDataQuestion()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [numberQuestion])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, 3].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema6.topic3.initScene, 3);
						ObserverEmitter.emit(EVENTS.tema6.topic3.actScene, "hide_desk_phone");
						setNumberQuestion(0)
						setSaveResponse(0)
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Ejercicio: Selecciona la opción faltante" />
					<DialogBarNew
						dialog={`¡Excelente trabajo! Ahora, completa los pasos para una recarga con código QR, de acuerdo a las opciones presentadas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3. Tiempo Aire Electrónico (TAE) con QR"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							// ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							ObserverEmitter.emit(EVENTS.tema6.topic3.actScene, "view_desk_phone");
							setUiToShow(steps.questions);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.questions && (
				<>
					<BarStatusActivies activities={tasksList} />
					<GameActivityThree data={selectQuestionGame} actionGameQuestion={actionGameQuestion} />
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={pointsAcumulated}
						dialogModal="Lo has hecho excelente, prosigamos con nuestros temas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema3
								})
							);
							navigator("/home6/tema6/subtema3/activityresult");
						}}
					/>
				</>
			)}
			{uiToShow === steps.fail && (
				<>
					<ValidationResultModal
						title="Respuesta incorrecta."
						numberPoints={pointsAcumulated}
						dialogModal="¡Tu puedes! recuerda repasar los temas para reforzar tu conocimiento."
						buttonTxt="Continuar"
						isCorrect={false}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 3,
									pointsWin: pointsAcumulated,
									subtema: tasksId.tema6.activities.subtema3
								})
							);
							navigator("/home6/tema6/subtema3/activityresult");
						}}
					/>
				</>
			)}
		</>
	)
}
